<template>
  <div class="d-flex align-items-center">
    <b-nav-item v-if="!isLoggedIn" @click="goLogin">
      登录/注册
    </b-nav-item>
    <template v-else>
      <!-- 站内通知铃铛 -->
      <b-nav-item 
        class="notification-bell-btn mr-1" 
        @click="openNotificationModal"
        title="站内通知"
      >
        <span class="position-relative d-inline-block">
          <b-icon icon="bell" font-scale="1.15"></b-icon>
          <span 
            v-if="unreadNotificationsCount > 0" 
            class="badge badge-pill badge-danger notification-badge"
          >
            {{ unreadNotificationsCount > 99 ? '99+' : unreadNotificationsCount }}
          </span>
        </span>
      </b-nav-item>

      <b-nav-item-dropdown right :dropup="isMobile">
        <template #button-content>
          <span v-if="avatarUrl" class="d-inline-block mr-2" style="width:24px;height:24px;border-radius:50%;overflow:hidden;vertical-align:middle;">
            <img :src="avatarUrl" style="width:24px;height:24px;object-fit:cover;" />
          </span>
          <span v-else class="avatar-fallback-mini mr-2">{{ firstLetter }}</span>
          <span class="user-display-name">{{ displayName }}</span>
        </template>
        <b-dropdown-item @click="openNotificationModal">
          <b-icon icon="bell" class="mr-2"></b-icon>
          站内通知
          <b-badge v-if="unreadNotificationsCount > 0" variant="danger" pill class="ml-1">
            {{ unreadNotificationsCount }}
          </b-badge>
        </b-dropdown-item>
        <b-dropdown-item @click="openApkDownloadModal">
          <b-icon icon="phone" class="mr-2"></b-icon>App下载
        </b-dropdown-item>
        <b-dropdown-item @click="toggleTheme">{{ themeLabel }}</b-dropdown-item>
        <b-dropdown-item @click="toggleColorblind">{{ colorblindLabel }}</b-dropdown-item>
        <b-dropdown-item @click="goApiUsage">
          <b-icon icon="graph-up" class="mr-2"></b-icon>用量报表
        </b-dropdown-item>
        <b-dropdown-item @click="goProfile">设置</b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item @click="logout">退出登录</b-dropdown-item>
      </b-nav-item-dropdown>

      <!-- 站内通知弹窗组件 -->
      <NotificationModal ref="notifyModal" @unread-changed="onUnreadCountChanged" />
      <!-- APK下载弹窗组件 -->
      <ApkDownloadModal ref="apkDownloadModal" />
    </template>
  </div>
</template>

<script>
import { request_zzquant } from '@/network/request.js'
import NotificationModal from '@/components/notification/NotificationModal.vue'
import ApkDownloadModal from '@/components/download/ApkDownloadModal.vue'

export default {
  name: 'UserMenu',
  components: {
    NotificationModal,
    ApkDownloadModal,
  },
  data() {
    return {
      isLoggedIn: false,
      userInfo: null,
      loginHandlerRef: null,
      logoutHandlerRef: null,
      theme: 'light',
      colorblind: false,
      isMobile: false,
      unreadNotificationsCount: 0,
    }
  },
  computed: {
    displayName() {
      const u = this.userInfo || {}
      return u.user_nick || u.user_name || u.email || '账户'
    },
    avatarUrl(){
      const u = this.userInfo || {}
      const url = u.avatar_url || u.avatar
      if (!url) return ''
      return url.startsWith('http') ? url : ('https://api.zizizaizai.com' + url)
    },
    firstLetter(){
      const name = this.displayName || ''
      return name ? name.substr(0,1) : '?'
    },
    themeLabel(){ return this.theme === 'dark' ? '浅色皮肤' : '黑色皮肤' },
    colorblindLabel(){ return this.colorblind ? '关闭色弱模式' : '开启色弱模式' }
  },
  mounted() {
    this.readLocal()
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
    try{ const t = localStorage.getItem('site.theme'); if(t){ this.theme = t } }catch(e){ console.warn('theme read failed', e) }
    try{ const c = localStorage.getItem('site.colorblind'); if(c){ this.colorblind = (c==='1' || c==='true') } }catch(e){ console.warn('colorblind read failed', e) }
    this.loginHandlerRef = (evt) => {
      try {
        if (evt && evt.detail && evt.detail.userInfo) {
          this.userInfo = evt.detail.userInfo
        }
      } catch (e) { console.warn('user-login event parse failed', e) }
      this.isLoggedIn = !!localStorage.getItem('token')
    }
    this.logoutHandlerRef = () => {
      this.isLoggedIn = false
      this.userInfo = null
    }
    window.addEventListener('user-login', this.loginHandlerRef)
    window.addEventListener('user-logout', this.logoutHandlerRef)
    if (this.isLoggedIn) {
      this.loadProfile()
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
    window.removeEventListener('user-login', this.loginHandlerRef)
    window.removeEventListener('user-logout', this.logoutHandlerRef)
  },
  methods: {
    readLocal() {
      try {
        this.isLoggedIn = !!localStorage.getItem('token')
        const raw = localStorage.getItem('user_info')
        if (raw) this.userInfo = JSON.parse(raw)
      } catch (e) {
        this.isLoggedIn = !!localStorage.getItem('token')
        this.userInfo = null
        console.warn('readLocal user_info failed', e)
      }
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 991
    },
    goLogin() {
      try {
        const current = this.$router.currentRoute && this.$router.currentRoute.fullPath ? this.$router.currentRoute.fullPath : '/'
        this.$router.push({ path: '/login', query: { redirect: current } })
      } catch (e) {
        this.$router.push('/login')
      }
    },
    goProfile() {
      if (!this.$route || this.$route.path !== '/me/profile') {
        this.$router.push('/me/profile').catch(() => {})
      }
    },
    goApiUsage() {
      if (!this.$route || this.$route.path !== '/me/profile' || this.$route.query.tab !== 'usage') {
        this.$router.push('/me/profile?tab=usage').catch(() => {})
      }
    },
    goHome() {
      if (!this.$route || this.$route.path !== '/me/home') {
        this.$router.push('/me/home').catch(() => {})
      }
    },
    applyTheme(){ const isDark = this.theme === 'dark'; document.body.classList.toggle('theme-dark', isDark); try{ localStorage.setItem('site.theme', this.theme); window.dispatchEvent(new CustomEvent('site-theme-changed', { detail:{ theme:this.theme } })) }catch(e){ console.warn('theme set failed', e) } },
    toggleTheme(){ this.theme = (this.theme==='dark') ? 'light' : 'dark'; this.applyTheme() },
    applyColorblind(){ try{ localStorage.setItem('site.colorblind', this.colorblind ? '1' : '0'); window.dispatchEvent(new CustomEvent('site-colorblind-changed', { detail:{ colorblind: !!this.colorblind } })) }catch(e){ console.warn('colorblind set failed', e) } },
    toggleColorblind(){ this.colorblind = !this.colorblind; this.applyColorblind() },
    loadProfile(){
      request_zzquant({ url: '/v3/user/profile/me', method: 'GET' }).then(res => {
        const d = res.data && res.data.data ? res.data.data : {}
        const info = Object.assign({}, this.userInfo || {}, { id: d.id, user_name: d.user_name, user_nick: d.user_nick, avatar_url: d.avatar_url })
        if (d.roles) {
          info.roles = d.roles
        }
        this.userInfo = info
        try { 
          localStorage.setItem('user_info', JSON.stringify(info))
          window.dispatchEvent(new CustomEvent('user-profile-updated', { detail: info }))
        } catch(e) { console.warn('persist user_info failed', e) }
      }).catch(()=>{})
    },
    async logout() {
      const current = this.$router.currentRoute && this.$router.currentRoute.fullPath ? this.$router.currentRoute.fullPath : '/'
      try {
        await request_zzquant({ url: '/v3/auth/logout', method: 'post' })
      } catch (e) {
        console.warn('logout api failed', e)
      } finally {
        try {
          localStorage.removeItem('token')
          localStorage.removeItem('refresh_token')
          localStorage.removeItem('user_info')
        } catch (e) { console.warn('clear local auth failed', e) }
        window.dispatchEvent(new CustomEvent('user-logout'))
        this.$router.push({ path: '/login', query: { redirect: current } })
      }
    },
    openNotificationModal() {
      if (this.$refs.notifyModal) {
        this.$refs.notifyModal.open()
      }
    },
    openApkDownloadModal() {
      if (this.$refs.apkDownloadModal) {
        this.$refs.apkDownloadModal.open()
      } else {
        this.$router.push('/download')
      }
    },
    onUnreadCountChanged(count) {
      this.unreadNotificationsCount = count
    }
  }
}
</script>

<style scoped>
.avatar-fallback-mini {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: var(--accent-color, #f0b90b);
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  vertical-align: middle;
}

.user-display-name {
  vertical-align: middle;
}

.notification-badge {
  position: absolute;
  top: -6px;
  right: -10px;
  font-size: 0.65rem;
  padding: 0.2em 0.45em;
  line-height: 1;
}

.notification-bell-btn >>> .nav-link {
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
  color: rgba(255, 255, 255, 0.75) !important;
  transition: color 0.2s;
  cursor: pointer;
}

.notification-bell-btn:hover >>> .nav-link {
  color: #ffffff !important;
}
</style>
